module.exports = __webpack_public_path__ + "static/media/notimg5.ece93a73.svg";